module.exports = __webpack_public_path__ + "static/media/JustMkt.f46ccbf4.png";